// extracted by mini-css-extract-plugin
export var text = "_85-0";